module.exports = __webpack_public_path__ + "img/apple-black.4733be05.svg";